module.exports = __webpack_public_path__ + "assets/img/driver-btn-9d6c247b.png";